export type RouteAudience = 'guest' | 'host' | 'both';
export type RouteLayout = 'navigational' | 'standalone' | 'modal';

export type RouteDescriptor = {
  id: string;
  path: string;
  label: string;
  audience: RouteAudience;
  layout: RouteLayout;
  module: string;
  modal?: boolean;
};

export type RouteHandle = { route: RouteDescriptor };

export const createRouteHandle = (
  descriptor: RouteDescriptor,
): RouteHandle => ({
  route: descriptor,
});

export type RouteSummary = Pick<
  RouteDescriptor,
  'id' | 'path' | 'audience' | 'layout' | 'modal'
>;
